import { RegularHistorytAcceptActivityPayrollFilesPage } from "@/features/regular-document/pages/acceptance-activity-document/RegularHistorytAcceptActivityPayrollFiles";

const RegularHistoryAcceptanceActivityPayrollFiles = () => {
  return <RegularHistorytAcceptActivityPayrollFilesPage />;
};

export default RegularHistoryAcceptanceActivityPayrollFiles;
